import React, { useEffect, useState } from 'react';
import styles from './Circle.module.css';
import smallCircle from "../../../../img/smallCircle.svg";
import middleCircle from "../../../../img/middleCircle.svg";
import bigCircle from "../../../../img/bigCircle.svg";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Parameters from './Parameters';
import OuterCounter from './OuterCounter';
import { useSwipeable } from 'react-swipeable';


const Circle = ({ status, station }) => {
    const [visibleIndex, setVisibleIndex] = useState(1);
    const [currentParamIndex, setCurrentParamIndex] = useState(0);
    const [currentParamDataIndex, setCurrentParamDataIndex] = useState(0);

    let lang = localStorage.getItem('language') === 'ru';

    const formatPowerBattery = (power) => {
        if (!power) {
            return "0.0";
        }
        const parsePower = (power * 1).toFixed(1);
        return parsePower;
    };

    const formatAmperege = (amperage) => {
        if (!amperage) {
            return "0.0";
        }
        const parseAmpere = (amperage * 1).toFixed(1);
        return parseAmpere;
    };

    const formatPower = (power) => {
        if (!power) {
            return "0.0";
        }
        const parsePower = (power / 1000).toFixed(1);
        return parsePower;
    };

    const formatTime = (seconds) => {
        if (seconds == null) {
            return "00:00";
        }
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    };

    const formatPowerCommon = (power) => {
        return (power / 1).toFixed(1);
    }

    const formatConsumedEnergy = (power) => {
        return (power / 100).toFixed(1);
    }

    const parameterData = [
        {
            label: "Energy",
            value: formatConsumedEnergy(station?.connectors[0]?.consumedEnergy),
            unit: lang ? "кВтч" : "kWh"
        },
        {
            label: "Power",
            value: formatPowerCommon(station?.connectors[0]?.powerCommon),
            unit: lang ? "кВт" : "kW"
        },
        {
            label: "Time",
            value: formatTime(station?.connectors[0]?.chargingTime), // Пример, зависит от API
        }
    ];

    const currentParam = parameterData[currentParamDataIndex];

    useEffect(() => {
        const interval = setInterval(() => {
            setVisibleIndex((prev) => (prev === 3 ? 1 : prev + 1));
        }, 1000); // каждые 1 секунда

        return () => clearInterval(interval);
    }, []);

    const handleNext = () => {
        setCurrentParamIndex(currentParamIndex === 0 ? 1 : 0);
    };

    const handleNextParameter = () => {
        if (currentParamIndex === 1) return;
        setCurrentParamDataIndex((prev) => (prev + 1) % parameterData.length);
        // setCurrentParamIndex(currentParamIndex === 0 ? 1 : 0);
    };

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => setCurrentParamIndex(currentParamIndex === 0 ? 1 : 0),
        onSwipedRight: () => setCurrentParamIndex(currentParamIndex === 1 ? 0 : 1),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true, // позволяет свайп мышкой для удобства отладки
    });

    return (
        <div className={styles.circleWrapper}>
            <div {...swipeHandlers} className={styles.cirlceButtons}>
                <button onClick={handleNext} className={styles.arrow}><ChevronLeft size={24} /></button>
                <div className={styles.circle}
                    onClick={handleNextParameter}>
                    <img src={smallCircle} className={styles.circleImage} style={{ opacity: 1 }} alt="small" />
                    {status === "Charging" && (
                        <>
                            <img src={middleCircle} className={styles.circleImage1} style={{ opacity: visibleIndex >= 2 ? 1 : 0 }} alt="middle" />
                            <img src={bigCircle} className={styles.circleImage2} style={{ opacity: visibleIndex === 3 ? 1 : 0 }} alt="big" />
                        </>
                    )}
                    <p className={styles.textCircle}>
                        {currentParamIndex === 0 ? (
                            <div className={styles.textCircle}>
                                <span className={styles.parameter}>{parameterData[currentParamDataIndex]?.value}</span>
                                <span className={styles.unit}>{parameterData[currentParamDataIndex]?.unit ? parameterData[currentParamDataIndex]?.unit : ""}</span>
                            </div>
                        ) : (
                            <div className={styles.textCircle}>
                                <span className={styles.parameter}>{formatPowerBattery(station?.connectors[0]?.pm)}</span>
                                <span className={styles.unit}>{lang ? "кВт" : "kW"}</span>
                            </div>
                        )}
                    </p>
                </div>
                <button onClick={handleNext} className={styles.arrow}><ChevronRight size={24} /></button>
            </div>
            <div className={styles.dots}>
                <span className={currentParamIndex === 1 ? styles.dot : styles.activeDot} />
                <span className={currentParamIndex === 0 ? styles.dot : styles.activeDot} />
            </div>
            {currentParamIndex === 1 ? (
                <OuterCounter connector={station?.connectors[0]} />
            ) : (
                <Parameters connector={station?.connectors[0]} />
            )}
        </div>
    )
}

export default Circle;